export const AppConstants = {
  touchtoorder: " TOUCH TO ORDER",
  DEFAULT_REMOTE_URL: "api",
  PIN: "32140",
};
export const PaymentResponseConstants = {
  completed: "COMPLETED",
  failed: "FAILED",
  failed_timeout: "TIMED_OUT",
  pending: "PENDING",
};
export const StatusConstants = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  SOLDOUT: "SOLDOUT",
};
export const PaymentStatusConstants = {
  success: "SUCCESS",
  failed: "FAILED",
  timeout: "TIMEOUT",
  pending: "PENDING",
};

export const TerminalTypes = {
  MERCHANT: "merchant-billing",
  USER: "user-billing",
};
export const AppTypes = {
  KIOSK_LINUX: "linux-kiosk",
  KIOSK_WINDOWS: "windows-kiosk",
  ANDROID_APK_MERCHANT: "android-merchant",
  ANDROID_APK_USER: "android-user",
  IPAD_OR_IOS_APPSTORE_MERCHANT: "ios-merchant",
  IPAD_OR_IOS_APPSTORE_USER: "ios-user",
  DESKTOP_LINUX: "linux-merchant",
  DESKTOP_WINDOWS: "windows-merchant",
  WEB_MERCHANT: "web-merchant",
  WEB_USER: "web-user",
};

export const DEVICE_TYPES = {
  ANDROID_MOBILE: "Android Mobile",
  ANDROID_TABLET: "Android Tablet",
  IPAD: "Ipad",
  MAC: "Mac",
  MAC_DESKTOP_APP: "Mac Desktop App",
  IPHONE: "IPhone",
  LINUX: "Linux",
  LINUX_DESKTOP: "Linux Desktop",
  WINDOWS_DESKTOP: "Windows Desktop",
  UNKNOWN: "Unknown",
};

export const StorageConstants = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  MERCHANT_DETAILS: "merchantDetails",
  ACCOUNT_BACKUP_DETAILS: "accountBackupDetails",
  CUSTOM_CODE_MODE: "CustomCodeMode",
  CUSTOM_CODE_TYPE: "CustomCodeType",
  CUSTOM_CODES: "CustomCodes",
  PRINT_MODE: "PRINT_MODE",
  DEVICE_UNIQUE_ID: "deviceUniqueId",
  PRINTER_VID_PID: "PRINTER_VID_PID",
  KOT_PRINTER_CONFIG: "KOT_PRINTER_CONFIG",
  PARCEL_KOT_PRINTER_CONFIG: "PARCEL_KOT_PRINTER_CONFIG",
  ORDER_ID_PREFIX: "ORDER_ID_PREFIX",
  IS_DISABLE_COUNTER_VIEW: "is_Disable_Counter_View",
  DEFAULT_COUNTER: "default_counter",
  PAYMENT_CHECK_INTERVAL: "PAYMENT_CHECK_INTERVAL",
  PRIMARY_THEME_COLOR: "PRIMARY_THEME_COLOR",
  SECONDARY_THEME_COLOR: "SECONDARY_THEME_COLOR",
  REMOTE_URL: "REMOTE_URL",
  ALREADY_PRINTED: "ALREADY_PRINTED",
  KOT_DELAY: "KOT_DELAY",
  ALL_ADDONS_LIST: 'allAddOnsList',
  ALL_GROUP_LIST: 'allGroupList',
};

export const PRINT_CONSTANT = {
  POS: "POS",
  PDF: "PDF",
  POS_BLUETOOTH: "POS_BLUETOOTH",
  POS_USB: "POS_USB",
  POS_LAN: "POS_LAN",
  POS_BLUETOOTH_58MM: "POS_BLUETOOTH_58MM",
  POS_BLUETOOTH_72MM: "POS_BLUETOOTH_72MM",
  POS_BLUETOOTH_80MM: "POS_BLUETOOTH_80MM",
  POS_USB_58MM: "POS_USB_58MM",
  POS_USB_72MM: "POS_USB_72MM",
  POS_USB_80MM: "POS_USB_80MM",
  POS_LAN_58MM: "POS_LAN_58MM",
  POS_LAN_80MM: "POS_LAN_80MM",
  POS_LAN_72MM: "POS_LAN_72MM",
  SUNMI: "SUNMI",
};
export const USER_AGENTS = {
  REACT_NATIVE: "REACT_NATIVE_AGENT",
  PRINT_RAW: "PRINTRAW=TRUE",
  isSUNMI: "SUNMI=TRUE",
  WEIGHT_SCALE: "WEIGHT_SCALE=TRUE",
  ISVERSION017: "PRINTIMAGE=TRUE;",
};
export const DASHBOARD_PATH = {
  ROOT: "dashboard",
  MENU: "menu",
  PAYMENT: "payment",
  PAYMENT_STATUS: "paymentstatus",
  MODE: "mode",
  THANKYOU: "thankyou",
  COUNTER: "counter",
  SCAN_QR_PRINT: "scanqrprint",
};
export var PRINTER_COMMANDS = {
  LF: "\x0a",
  ESC: "\x1b",
  FS: "\x1c",
  GS: "\x1d",
  US: "\x1f",
  FF: "\x0c",
  DLE: "\x10",
  DC1: "\x11",
  DC4: "\x14",
  EOT: "\x04",
  NUL: "\x00",
  EOL: "\n",
  HORIZONTAL_LINE: {
    HR_58MM: "==================================",
    HR2_58MM: "**********************************",
    HR3_58MM: "----------------------------------",
    HR_80MM: "================================================",
    HR2_80MM: "************************************************",
    HR3_80MM: "------------------------------------------------",
  },
  FEED_CONTROL_SEQUENCES: {
    /**
     * Print and line feed
     */
    CTL_LF: "\x0a",
    /**
     * Form feed
     */
    CTL_FF: "\x0c",
    /**
     * Carriage return
     */
    CTL_CR: "\x0d",
    /**
     * Horizontal tab
     */
    CTL_HT: "\x09",
    /**
     * Vertical tab
     */
    CTL_VT: "\x0b",
  },
  LINE_SPACING: {
    LS_DEFAULT: "\x1b\x32",
    LS_SET: "\x1b\x33",
    LS_SET1: "\x1b\x31",
  },
  HARDWARE: {
    /**
     * Clear data in buffer and reset modes
     */
    HW_INIT: "\x1b\x40",
    /**
     * Printer select
     */
    HW_SELECT: "\x1b\x3d\x01",
    /**
     * Reset printer hardware
     */
    HW_RESET: "\x1b\x3f\x0a\x00",
  },
  CASH_DRAWER: {
    /**
     * Sends a pulse to pin 2 []
     */
    CD_KICK_2: "\x1b\x70\x00",
    /**
     * ends a pulse to pin 5 []
     */
    CD_KICK_5: "\x1b\x70\x01",
  },
  MARGINS: {
    /**
     * Fix bottom size
     */
    BOTTOM: "\x1b\x4f",
    /**
     * Fix left size
     */
    LEFT: "\x1b\x6c",
    /**
     * Fix right size
     */
    RIGHT: "\x1b\x51",
  },
  PAPER: {
    /**
     * Full cut paper
     */
    PAPER_FULL_CUT: "\x1d\x56\x00",
    /**
     * Partial cut paper
     */
    PAPER_PART_CUT: "\x1d\x56\x01",
    /**
     * Partial cut paper
     */
    PAPER_CUT_A: "\x1d\x56\x41",
    /**
     * Partial cut paper
     */
    PAPER_CUT_B: "\x1d\x56\x42",
  },
  TEXT_FORMAT: {
    /**
     * Normal text
     */
    TXT_NORMAL: "\x1b\x21\x00",
    /**
     * Double height text
     */
    TXT_2HEIGHT: "\x1b\x21\x10",
    /**
     * Double width text
     */
    TXT_2WIDTH: "\x1b\x21\x20",
    /**
     * Double width & height text
     */
    TXT_4SQUARE: "\x1b\x21\x30",
    /**
     * other sizes
     */
    TXT_CUSTOM_SIZE: function (width, height) {
      var widthDec = (width - 1) * 16;
      var heightDec = height - 1;
      var sizeDec = widthDec + heightDec;
      return "\x1d\x21" + String.fromCharCode(sizeDec);
    },
    TXT_HEIGHT: {
      1: "\x00",
      2: "\x01",
      3: "\x02",
      4: "\x03",
      5: "\x04",
      6: "\x05",
      7: "\x06",
      8: "\x07",
    },
    TXT_WIDTH: {
      1: "\x00",
      2: "\x10",
      3: "\x20",
      4: "\x30",
      5: "\x40",
      6: "\x50",
      7: "\x60",
      8: "\x70",
    },
    /**
     * Underline font OFF
     */
    TXT_UNDERL_OFF: "\x1b\x2d\x00",
    /**
     * Underline font 1-dot ON
     */
    TXT_UNDERL_ON: "\x1b\x2d\x01",
    /**
     * Underline font 2-dot ON
     */
    TXT_UNDERL2_ON: "\x1b\x2d\x02",
    /**
     * Bold font OFF
     */
    TXT_BOLD_OFF: "\x1b\x45\x00",
    /**
     * Bold font ON
     */
    TXT_BOLD_ON: "\x1b\x45\x01",
    /**
     * Italic font ON
     */
    TXT_ITALIC_OFF: "\x1b\x35",
    /**
     * Italic font ON
     */
    TXT_ITALIC_ON: "\x1b\x34",
    /**
     * Font type A
     */
    TXT_FONT_A: "\x1b\x4d\x00",
    /**
     * Font type B
     */
    TXT_FONT_B: "\x1b\x4d\x01",
    /**
     * Font type C
     */
    TXT_FONT_C: "\x1b\x4d\x02",
    /**
     * Left justification
     */
    TXT_ALIGN_LT: "\x1b\x61\x00",
    /**
     * Centering
     */
    TXT_ALIGN_CT: "\x1b\x61\x01",
    /**
     *  Right justification
     */
    TXT_ALIGN_RT: "\x1b\x61\x02",
  },
};
export const DEFAULT_BLUETOOTH_PRINT_CONNECTION = {
  DEFAULT: "DEFAULT",
  COUNTER_MODE: "COUNTER_MODE",
  STICKY_MODE: "STICKY_MODE",
};
export const DEFAULT_KOT_DELAY = 1000;
export const KOT = {
  DEFAULT: "Default",
  SMALL: "Small",
  MEDIUM: "Medium",
  LARGE: "Large",
};
export const fontSizeMarker = {
  Small: "\x1B\x21\x00",
  Medium: "\x1B\x21\x20\x1C\x21\x04",
  Large: "\x1D\x21\x11",
  Default: "\x1B\x21\x00",
};
export const OrderTypeConstants = {
  DineIn: "DINE-IN",
  Parcel: "PARCEL",
  Delivery: "DELIVERY",
};

export const OrderTypeConstants_Labels = {
  "DINE-IN": "Dine In",
  PARCEL: " Parcel",
  Delivery: "Delivery",
};
export const defaultOrderTypes = [
  OrderTypeConstants.DineIn,
  OrderTypeConstants.Parcel,
];
export const ORDER_POSITION = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
};
export const PaymentModeTypeConstants = {
  CARD: "CARD",
  CASH: "CASH",
  UPI: "UPI",
  ZOMATO: "ZOMATO",
  SWIGGY: "SWIGGY",
};
export const sizeMap = {
  [PRINT_CONSTANT.POS_BLUETOOTH_80MM]: 48,
  [PRINT_CONSTANT.POS_USB_80MM]: 48,
  [PRINT_CONSTANT.POS_LAN_80MM]: 48,
  [PRINT_CONSTANT.POS_BLUETOOTH_58MM]: 28,
  [PRINT_CONSTANT.POS_USB_58MM]: 28,
  [PRINT_CONSTANT.POS_LAN_58MM]: 28,
  [PRINT_CONSTANT.POS_BLUETOOTH_72MM]: 42,
  [PRINT_CONSTANT.POS_USB_72MM]: 42,
  [PRINT_CONSTANT.POS_LAN_72MM]: 42,
  [PRINT_CONSTANT.SUNMI]: 32,
};
export const DEFAULT_LOGO_HEIGHT_WIDTH = { imageWidth: 100, imageHeight: 70 };
export const DEFAULT_QR_HEIGHT_WIDTH = {
  SMALL_QR: { imageHeight: 100, imageWidth: 100 },
  MEDIUM_QR: { imageHeight: 150, imageWidth: 150 },
  LARGE_QR: { imageHeight: 200, imageWidth: 200 },
  SMALL_QR_ANDROID: { imageHeight: 200, imageWidth: 200 },
  MEDIUM_QR_ANDROID: { imageHeight: 250, imageWidth: 250 },
  LARGE_QR_ANDROID: { imageHeight: 300, imageWidth: 300 },
};

export const QR_SIZES = [
  { value: "SMALL_QR", label: "Small" },
  { value: "MEDIUM_QR", label: "Medium" },
  { value: "LARGE_QR", label: "Large" },
];
export const DEFAULT_REVIEW_QR_SIZE = QR_SIZES[0].value;
export const DEFAULT_PAYMENT_QR_SIZE = QR_SIZES[0].value;
export const REVIEW_QR_TYPE = [
  { value: "POSTIEASY_LINK", label: "Positeasy Link" },
  { value: "CUSTOM_LINK", label: "Custom Link" },
];
export const PARCEL_KEYS = ["PARCEL", "DELIVERY"];
